import END_POINT from 'src/config/endpoints.constants';
import { ApiResponse, ApiResult, getErrorMessage } from '../lib/API';
import { UUID } from '../types';
import axios from 'axios';
export interface HangupCallResult extends ApiResult {
    data?: {
        message: string;
    };
}

export interface HangupCallResponse extends ApiResponse {
    data: null;
}

export interface HangupCallOptions {
    roomname: UUID;
}

export default async function hangupCall(options: HangupCallOptions) {
    const result: HangupCallResult = {};
    try {
        const { data: responseData } = await axios.post<HangupCallResponse>(
            END_POINT.END_VIDEO_ROOM,
            options,
        );
        if (responseData) {
            // TODO: handle "Room does not belong to the interpreter." error
            // TODO: handle "Room completion failed. The requested resource was not found"
            if (responseData.code === 0 || responseData.code === 1 || responseData.code === 2) {
                result.data = {
                    message: responseData.message,
                };
            } else {
                result.error = responseData.message;
            }
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
